
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Popup from '@/components/utils/Popup.vue';
import { CHANGE_ROOM_SETTINGS_ERROR } from '@/utils/constants';

@Component({ components: { Popup } })
export default class FloorPlanSettingsPopup extends Vue {
  // @Prop() private dataService!: RoomDataService;
  // @Prop() private colorTheme: ColorTheme | undefined;
  // @Prop() private subRoomNumber: SubRoomNumber | undefined;
  // @Prop() private room!: string;
  // @Prop() private space!: string;
  // @Prop() private participantsPresent!: boolean;
  // @Prop() private isVisible!: boolean;
  // @Prop() private restartRoom!: () => void;
  // private chosenRoomType = "newtype";
  // private chosenColorTheme: ColorTheme | undefined = "blue";
  // private chosenSubRoomNumber: SubRoomNumber | undefined = 0;
  // private isSettingChanged = false;
  // private error = CHANGE_ROOM_SETTINGS_ERROR;
  // mounted() {
  //   this.chosenRoomType = this.subRoomNumber == 5 ? "newtype" : "oldtype";
  //   this.chosenColorTheme = this.colorTheme;
  //   this.chosenSubRoomNumber = this.subRoomNumber == 5 ? 0 : this.subRoomNumber;
  // }
  // @Watch("colorTheme")
  // private onColorThemeChanged(currentColorTheme: ColorTheme) {
  //   this.chosenColorTheme = currentColorTheme;
  // }
  // @Watch("subRoomNumber")
  // private onSubRoomNumberChanged(currentSubRoomNumber: SubRoomNumber) {
  //   this.chosenSubRoomNumber = currentSubRoomNumber;
  // }
  // private hidePopup(): void {
  //   this.chosenColorTheme = this.colorTheme;
  //   this.chosenSubRoomNumber = this.subRoomNumber;
  //   this.$emit("close");
  // }
  // private changeRoomType(roomType: string): void {
  //   this.chosenRoomType = roomType;
  //   this.setIsSettingsChanged();
  // }
  // private changeColorTheme(colorTheme: ColorTheme): void {
  //   this.chosenColorTheme = colorTheme;
  //   this.setIsSettingsChanged();
  // }
  // private changeSubRoomNumber(subRoomNumber: SubRoomNumber): void {
  //   this.chosenSubRoomNumber = subRoomNumber;
  //   this.setIsSettingsChanged();
  // }
  // private setIsSettingsChanged(): void {
  //   if (this.colorTheme !== this.chosenColorTheme || this.subRoomNumber !== this.chosenSubRoomNumber) {
  //     this.isSettingChanged = true;
  //   } else {
  //     this.isSettingChanged = false;
  //   }
  // }
  // private onApplySettingsButtonClick(): void {
  //   if (this.isSettingChanged && !this.participantsPresent && this.room && this.space && this.chosenColorTheme && this.chosenSubRoomNumber !== undefined) {
  //     this.dataService.emitSetRoomSettings(this.room, this.space, this.chosenColorTheme, this.chosenRoomType == "newtype" ? 5 : this.chosenSubRoomNumber);
  //     this.restartRoom();
  //   } else {
  //     this.$emit("close");
  //   }
  // }
}
